import React from 'react'

const Column = props => {
  return null
}

export default Column
